import React from 'react';
import styled from 'styled-components';
import isNil from 'lodash/isNil';
import { useAppDispatch } from '../../../../redux/hooks';
import { dataModelerSetSamplingConfig } from '../../../../redux/slices/dataModeler';
import { DataModelerTabPanel, VerticalWrapper } from '../DataModelerCommonUI';
import SchemaSamplingRate from './SchemaSamplingRate';
import SchemaDataRefreshConfig from './SchemaDataRefreshConfig';
import { useDataModelerContext } from '../../DataModelerContext';

const Container = styled(VerticalWrapper)`
  width: 100%;
  max-width: 280px;
`;

const DataModelerOptimizationTab = () => {
  const dispatch = useAppDispatch();
  const { isEditMode, schemaObj, draftEdits } = useDataModelerContext();

  const defaultSample =
    draftEdits?.sampling?.default ?? schemaObj?.sampling?.default ?? 100;
  const cohortSample =
    draftEdits?.sampling?.cohort ?? schemaObj?.sampling?.cohort ?? 100;

  const setCohortSample = (n: number | null) => {
    if (isNil(n)) {
      return;
    }
    dispatch(
      dataModelerSetSamplingConfig({
        sample: defaultSample,
        cohort: n,
      }),
    );
  };

  const setDefaultSample = (n: number | null) => {
    if (isNil(n)) {
      return;
    }
    dispatch(
      dataModelerSetSamplingConfig({
        sample: n,
        cohort: cohortSample,
      }),
    );
  };

  return (
    <DataModelerTabPanel>
      <Container>
        <SchemaSamplingRate
          isEditMode={isEditMode}
          cohort={cohortSample}
          setCohort={setCohortSample}
          sample={defaultSample}
          setSample={setDefaultSample}
        />
        {schemaObj && (
          <SchemaDataRefreshConfig
            isEditMode={isEditMode}
            dataRefreshInput={draftEdits?.dataRefresh ?? null}
            dataRefreshMeta={schemaObj.dataRefresh}
          />
        )}
      </Container>
    </DataModelerTabPanel>
  );
};

export default DataModelerOptimizationTab;
